const deliveryStatus = {
    WAITING: "WAITING",
    DELIVERED: "DELIVERED",
    COMPLETE: "COMPLETE",
    CANCELLED: "CANCELLED"
}

const deliveryType = {
    PARCEL: "PARCEL",
    MAIL: "MAIL"
}

export {
    deliveryStatus,
    deliveryType
}